export default __webpack_public_path__ + "static/media/screenBlock3.ede30ebb.jpg";